import Icon from '@/components/ui/AppIcon';

interface ActivityItemProps {
  type: 'process' | 'task' | 'approval' | 'system';
  title: string;
  description: string;
  timestamp: string;
  user?: string;
  status?: 'success' | 'warning' | 'error' | 'info';
}

export default function ActivityItem({
  type,
  title,
  description,
  timestamp,
  user,
  status = 'info',
}: ActivityItemProps) {
  const getTypeIcon = () => {
    switch (type) {
      case 'process':
        return 'RectangleStackIcon';
      case 'task':
        return 'ClipboardDocumentCheckIcon';
      case 'approval':
        return 'CheckCircleIcon';
      case 'system':
        return 'CogIcon';
      default:
        return 'BellIcon';
    }
  };

  const getStatusColor = () => {
    switch (status) {
      case 'success':
        return 'bg-success/10 text-success';
      case 'warning':
        return 'bg-warning/10 text-warning';
      case 'error':
        return 'bg-error/10 text-error';
      default:
        return 'bg-accent/10 text-accent';
    }
  };

  return (
    <div data-component-id="src/app/main-dashboard/components/ActivityItem.tsx:49:4" data-component-path="src/app/main-dashboard/components/ActivityItem.tsx" data-component-line="49" data-component-file="ActivityItem.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20gap-4%20p-4%20hover%3Abg-muted%2F50%20rounded-lg%20transition-micro%22%7D" className="flex gap-4 p-4 hover:bg-muted/50 rounded-lg transition-micro">
      <div data-component-id="src/app/main-dashboard/components/ActivityItem.tsx:50:6" data-component-path="src/app/main-dashboard/components/ActivityItem.tsx" data-component-line="50" data-component-file="ActivityItem.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${getStatusColor()}`}>
        <Icon data-component-id="src/app/main-dashboard/components/ActivityItem.tsx:51:8" data-component-path="src/app/main-dashboard/components/ActivityItem.tsx" data-component-line="51" data-component-file="ActivityItem.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={getTypeIcon() as any} size={20} />
      </div>
      <div data-component-id="src/app/main-dashboard/components/ActivityItem.tsx:53:6" data-component-path="src/app/main-dashboard/components/ActivityItem.tsx" data-component-line="53" data-component-file="ActivityItem.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex-1%20min-w-0%22%7D" className="flex-1 min-w-0">
        <p data-component-id="src/app/main-dashboard/components/ActivityItem.tsx:54:8" data-component-path="src/app/main-dashboard/components/ActivityItem.tsx" data-component-line="54" data-component-file="ActivityItem.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20font-medium%20text-foreground%20mb-1%22%7D" className="text-sm font-medium text-foreground mb-1">{title}</p>
        <p data-component-id="src/app/main-dashboard/components/ActivityItem.tsx:55:8" data-component-path="src/app/main-dashboard/components/ActivityItem.tsx" data-component-line="55" data-component-file="ActivityItem.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-muted-foreground%20mb-2%22%7D" className="text-sm text-muted-foreground mb-2">{description}</p>
        <div data-component-id="src/app/main-dashboard/components/ActivityItem.tsx:56:8" data-component-path="src/app/main-dashboard/components/ActivityItem.tsx" data-component-line="56" data-component-file="ActivityItem.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20gap-3%20text-xs%20text-muted-foreground%22%7D" className="flex items-center gap-3 text-xs text-muted-foreground">
          <span data-component-id="src/app/main-dashboard/components/ActivityItem.tsx:57:10" data-component-path="src/app/main-dashboard/components/ActivityItem.tsx" data-component-line="57" data-component-file="ActivityItem.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D">{timestamp}</span>
          {user && (
            <>
              <span data-component-id="src/app/main-dashboard/components/ActivityItem.tsx:60:14" data-component-path="src/app/main-dashboard/components/ActivityItem.tsx" data-component-line="60" data-component-file="ActivityItem.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22%E2%80%A2%22%7D">•</span>
              <span data-component-id="src/app/main-dashboard/components/ActivityItem.tsx:61:14" data-component-path="src/app/main-dashboard/components/ActivityItem.tsx" data-component-line="61" data-component-file="ActivityItem.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D">{user}</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
}